import { Circle, Line } from '@react-three/drei';
import React from 'react';
export var CircleShape = function (_a) {
    var position = _a.position, rotation = _a.rotation, onRobotClick = _a.onRobotClick, robot = _a.robot, segment = _a.segment;
    var SCALED_RADIUS = 1.2;
    var rotatedX = position.x + SCALED_RADIUS * Math.cos(rotation.z - Math.PI / 2);
    var rotatedY = position.y + SCALED_RADIUS * Math.sin(rotation.z - Math.PI / 2);
    return (React.createElement(React.Fragment, null,
        React.createElement(Circle, { args: [SCALED_RADIUS, segment], position: position, rotation: rotation, onClick: onRobotClick },
            React.createElement("meshBasicMaterial", { color: robot.color })),
        React.createElement(Line, { points: [position.x, position.y, position.z, rotatedX, rotatedY, position.z], color: "black", linewidth: 2 })));
};
